"use client" // This is needed for client-side hooks like useState, useEffect, useRef

import { useEffect, useRef } from "react"
import "./UIBenefits.css"

const ScopingBenefits = () => {
  const benefits = [
    {
      iconSrc: "/pd1.webp?height=48&width=48", // Placeholder for your icon
      iconAlt: "Clear Guideline Icon",
      title: "GET A PROJECT PLAN",
      description: "Know the detailed steps, needed resources, expected costs and delivery time to build a functional and valuable product.",
    },
    {
      iconSrc: "/engagement.webp?height=48&width=48", // Placeholder for your icon
      iconAlt: "CREATE AN ENGAGING USER EXPERIENCE",
      title: "DATA-BASED DECISIONS",
      description: "Follow the necessary steps (from research and ideation to development and testing) to ensure a well-grounded and intuitive user experience.",
    },
    {
      iconSrc: "/calci.webp?height=48&width=48", // Placeholder for your icon
      iconAlt: "Business Plan Icon",
      title: "REDUCE TIME AND COSTS BY UP TO 50%",
      description: "Our Incremental Design Process (IDP) allows you to plan realistic schedules and avoid redesigning costs.",
    },
    {
      iconSrc: "/pd4.webp?height=48&width=48", // Placeholder for your icon
      iconAlt: "Focus Icon",
      title: "INCREASE PROFITABILITY",
      description:
        "Grow revenue and business value with a well-thought-out user experience that increases conversions.",
    },
  ]

  const headerRef = useRef(null)
  const descriptionRef = useRef(null)
  const cardRefs = useRef([]) // Use an array of refs for multiple cards

  useEffect(() => {
    console.log("ScopingBenefits component mounted. Setting up IntersectionObserver.")

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("visible")
            console.log(`Element ${entry.target.className} is now visible.`)
            observer.unobserve(entry.target) // Stop observing once visible
          }
        })
      },
      { threshold: 0.1 }, // Trigger when 10% of the element is visible
    )

    // Observe header and description
    if (headerRef.current) observer.observe(headerRef.current)
    if (descriptionRef.current) observer.observe(descriptionRef.current)

    // Observe each card
    cardRefs.current.forEach((card) => {
      if (card) observer.observe(card)
    })

    return () => {
      console.log("ScopingBenefits component unmounted. Cleaning up IntersectionObserver.")
      // Clean up observers on unmount
      if (headerRef.current) observer.unobserve(headerRef.current)
      if (descriptionRef.current) observer.unobserve(descriptionRef.current)
      cardRefs.current.forEach((card) => {
        if (card) observer.unobserve(card)
      })
    }
  }, [])

  return (
    <div className="scoping-benefits-container" id="benefits">
      <div className="container">
      <div className="scoping-benefits-wrapper">
        {/* Header Section */}
        <div className="scoping-benefits-header">
          <h2 className="scoping-benefits-title3133 animate-left" ref={headerRef}>
           We help you boost <br></br>your digital product
             
            
            
            <span className="scoping-benefits-highlight"> With UI/UX Design</span>
          </h2>
          <p className="scoping-benefits-description animate-left" ref={descriptionRef}>
            We design your web product or app platform from top to bottom and make sure it will skyrocket your product’s usability, efficiency, and success and, most importantly, addresses your users’ needs.
          </p>
        </div>

        {/* Benefits Grid */}
        <div className="scoping-benefits-grid">
          {benefits.map((benefit, index) => (
            <div
              key={index}
              className="scoping-benefit-card animate-up"
              ref={(el) => (cardRefs.current[index] = el)}
              style={{ "--animation-delay": `${index * 0.1}s` }} // Staggered animation
            >
              <div className="scoping-benefit-icon">
                <img src={benefit.iconSrc || "/placeholder.svg"} alt={benefit.iconAlt} className="scoping-icon-image" />
              </div>
              <h3 className="scoping-benefit-card-title">{benefit.title}</h3>
              <p className="scoping-benefit-card-description">{benefit.description}</p>
            </div>
          ))}
        </div>
      </div>
      </div>
    </div>
  )
}

export default ScopingBenefits
